import { Component, OnInit, ViewChild } from "@angular/core";
import { AssetsFetchService } from "../../services/app-data-fetch.service";
import * as _ from "lodash";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { FeedbackLibService } from "feedback-lib";
import { AssetAttributesModel } from "../../models/asset-attributes.model";
import { GlobalService } from "../../services/global/global.service";
import { AssetSearchModel } from "../../models/asset-search.model";
import { ConfirmationDialogService } from "../directives/confirmation-dialog/confirmation-dialog.service";

@Component({
  selector: "app-oeam-hierarchy",
  templateUrl: "./oeam-hierarchy.component.html",
  styleUrls: ["./oeam-hierarchy.component.scss"]
})
export class OeamHierarchyComponent implements OnInit {
  private readonly mainAssetID: string = "S";

  private goToIndex: string = "";
  private goToAssetNumber: string = "";
  public productionImpact: string = "";

  public assetsList = [];
  public attributeList = new AssetAttributesModel();

  public expandedKeys: any[] = [];
  public selectedKeys: any[] = [];

  public kendoSplitterOrientation: string = "horizontal";

  // Asset Search
  public searchAssetList: Array<AssetSearchModel> = [];

  @ViewChild("assetHierarchyKendo") assetHierarchyKendo: any;

  constructor(
    private assetfetchservice: AssetsFetchService,
    private feedbackService: FeedbackLibService,
    private globals: GlobalService,
    private confirmationService: ConfirmationDialogService
  ) {}

  ngOnInit(): void {
    if (this.globals.isMobile) this.kendoSplitterOrientation = "vertical";
    this.getFirstLevelOfAssets();
  }

  hideFeedback() {
    this.feedbackService.clear();
  }

  showFeedback(feedbackType: number, message: string) {
    this.feedbackService.displayFeedback(feedbackType, message);
    window.scrollTo(0, 0);
    setTimeout(() => this.hideFeedback(), 3000);
  }

  handleSelection(event: any) {
    this.getAssetsAttributes(event.dataItem.assetNumber);
  }

  handleChildrenLoaded(event) {
    // if (this.goToIndex) {
    //   this.redirectToIndex();
    // }
    setTimeout(() => {
      if (this.goToAssetNumber) {
        this.redirectToAsset();
      }
    }, 100);
  }

  public isItemSelected = (_: any, index: string) =>
    this.selectedKeys.indexOf(index) > -1;

  public fetchChildren = (node: any): Observable<any[]> => {
    let data = {
      parentAssetId: node.assetID
    };
    return this.assetfetchservice.getAssetsHierarchy(data).pipe(
      catchError(err => {
        this.showFeedback(3, "Failed to fetch Asset Hierarchy.");
        return throwError(err);
      })
    );
  };

  public hasChildren = (node: any): boolean => {
    return node.c4;
  };

  getFirstLevelOfAssets() {
    let data = {
      parentAssetId: this.mainAssetID
    };
    this.assetfetchservice.getAssetsHierarchy(data).subscribe(
      assets => {
        if (assets) {
          this.assetsList = assets || [];
        }
        if (this.assetsList.length > 0) {
          this.loadFirstAsset();
          if (!this.goToIndex)
            this.getAssetsAttributes(this.assetsList[0]["assetNumber"]);
        }
      },
      error => {
        this.showFeedback(3, "Failed to fetch Asset Hierarchy");
        console.log(error);
      }
    );
  }

  private loadFirstAsset() {
    let firstAsset: string = _.get((this.goToIndex || "").split("_"), 0) || "0";
    this.expandedKeys = [firstAsset];
    this.selectedKeys = [firstAsset];
  }

  getAssetsAttributes(assetNumber: string) {
    if (!assetNumber) return;
    let data = {
      assetNumber: assetNumber
    };
    this.assetfetchservice.getAssetsAttributes(data).subscribe(
      attributes => {
        attributes = _.get(attributes, 0) || new AssetAttributesModel();
        this.attributeList = attributes;
        this.modifyAttributes();
      },
      err => {
        this.showFeedback(3, "Failed to fetch Asset Attributes");
        console.log(err);
      }
    );
  }

  modifyAttributes() {
    // Remove Spaces
    _.mapValues(this.attributeList, attr => _.trim(attr));

    // Active Start Date
    if (_.includes(this.attributeList.activeStartDate, "1900"))
      this.attributeList["activeStartDate"] = "";

    // Active End Date
    if (_.includes(this.attributeList.activeEndDate, "1900"))
      this.attributeList["activeEndDate"] = "";

    // Shutdown Impacts Production
    if (this.attributeList.assetsImpactsProduction == "1")
      this.attributeList["assetsImpactsProduction"] = "Impact Production";
    else if (this.attributeList.assetsImpactsProduction == "0")
      this.attributeList["assetsImpactsProduction"] = "No Impact";
    else this.attributeList["assetsImpactsProduction"] = "Unknown";

    // Active
    this.attributeList["activeFlag"] =
      _.toUpper(this.attributeList.activeFlag) === "X" ? "Y" : "N";

    //Parent Asset Number
    if (this.attributeList.c1 == "S") this.attributeList["c1"] = "";
  }

  private redirectToIndex() {
    // No index found
    if (!this.goToIndex) return;

    // Index already selected
    if (this.assetHierarchyKendo.isSelected(_, this.goToIndex)) return;

    // Remove extra spaces from index mapping

    let assetIDs: string[] = _.map(
      _.filter(_.split(this.goToIndex, "_"), asset => asset),
      asset => asset.trim()
    );

    this.goToIndex = _.join(assetIDs, "_");

    // Clear expanded index
    this.expandedKeys = [];

    if (this.checkWeatherIndexIsAvailable(this.goToIndex)) {
      let tempKey = "";
      _.forEach(assetIDs, idx => {
        tempKey = tempKey ? `${tempKey}_${idx}` : `${idx}`;
        this.expandedKeys.push(tempKey);
      });
      this.selectedKeys = [this.goToIndex];

      // Get Asset Attributes
      this.getAssetsAttributes(
        this.getAssetNumberUsingKendoIndex(this.goToIndex)
      );

      // Scroll to selected asset
      this.scrollToAssetIndex(this.goToIndex);

      // Clear go to index as asset is selected
      this.goToIndex = "";
    } else {
      let lastIndexAvailable: string = "";
      let tempKey: string = "";

      // Select already expanded hierarchy
      _.forEach(assetIDs, idx => {
        tempKey = tempKey ? `${tempKey}_${idx}` : `${idx}`;
        if (this.checkWeatherIndexIsAvailable(tempKey)) {
          lastIndexAvailable = tempKey;
          this.expandedKeys.push(lastIndexAvailable);
        }
      });

      // Selected last available index
      if (lastIndexAvailable) this.selectedKeys = [lastIndexAvailable];

      // Select remaining hierarchy
      if (assetIDs.length !== this.expandedKeys.length) {
        let selectAsset: string = _.join(
          _.slice(assetIDs, 0, this.expandedKeys.length + 1),
          "_"
        );

        this.selectedKeys = [selectAsset];
        this.expandedKeys.push(selectAsset);
      } else {
        // Get Asset Attributes
        this.getAssetsAttributes(
          this.getAssetNumberUsingKendoIndex(this.goToIndex)
        );

        // Scroll to selected asset
        this.scrollToAssetIndex(this.goToIndex);

        // Clear go to index as asset is selected
        this.goToIndex = "";
      }
    }
  }

  private redirectToAsset() {
    // No index found
    if (!this.goToAssetNumber) return;

    let delimiter: string = "|~|";

    // Remove extra spaces from index mapping
    let assetNumbers: string[] = _.map(
      _.filter(_.split(this.goToAssetNumber, delimiter), asset => asset),
      asset => asset.trim()
    );

    let assetIndex: string = this.getAssetIndex(_.last(this.goToAssetNumber));

    // Index already selected
    if (this.assetHierarchyKendo.isSelected(_, assetIndex)) return;

    this.goToAssetNumber = _.join(assetNumbers, delimiter);

    // Clear expanded index
    this.expandedKeys = [];

    let lastIndexAvailable: string = "";
    let tempKey: string = "";

    // Select already expanded hierarchy
    _.forEach(assetNumbers, asset => {
      let idx = this.getAssetIndex(asset);
      tempKey = `${idx}`;
      if (this.checkWeatherIndexIsAvailable(tempKey)) {
        lastIndexAvailable = tempKey;
        this.expandedKeys.push(_.clone(lastIndexAvailable));
      }
    });

    // Selected last available index
    if (lastIndexAvailable) {
      this.selectedKeys = [lastIndexAvailable];
      this.scrollToAssetIndex(lastIndexAvailable);
    }

    // Select remaining hierarchy
    let selectAsset: string = _.last(
      _.slice(assetNumbers, 0, this.expandedKeys.length + 1)
    );

    let selectAssetIdx = this.getAssetIndex(selectAsset);
    if (selectAssetIdx) {
      this.selectedKeys = [selectAssetIdx];

      // Scroll to selected asset
      this.scrollToAssetIndex(selectAssetIdx);

      if (_.last(assetNumbers) != selectAsset) {
        this.expandedKeys.push(selectAssetIdx);
      }

      if (_.last(assetNumbers) == selectAsset) {
        // Get Asset Attributes
        this.getAssetsAttributes(
          this.getAssetNumberUsingKendoIndex(selectAssetIdx)
        );

        // Clear go to index as asset is selected
        this.goToAssetNumber = "";
      }
    }
  }

  public takeToNode(assetNumber: any) {
    if (
      _.toUpper(_.trim(assetNumber)) != _.toUpper(this.getActiveAssetNumber())
    ) {
      this.takeToAssetPath(assetNumber);
      // this.goToIndex = this.getAssetIndex(assetNumber);
      // this.redirectToIndex();
    }
  }

  private getAssetIndex(assetNumber: string): string {
    assetNumber = assetNumber ? _.toUpper(_.trim(assetNumber)) : "";

    let assetIndex: string = "";

    if (this.assetHierarchyKendo) {
      this.assetHierarchyKendo.treeViewLookupService.map.forEach(asset => {
        let item = _.get(asset, "item");
        let aNumber = _.get(_.get(item, "dataItem"), "assetNumber") || "";
        if (_.toUpper(_.trim(aNumber)) === assetNumber) {
          assetIndex = _.get(item, "index") || "";
        }
      });
    }
    return assetIndex;
  }

  private checkWeatherIndexIsAvailable(index: string): boolean {
    let available: boolean = false;
    if (this.assetHierarchyKendo) {
      available = this.assetHierarchyKendo.treeViewLookupService.hasItem(index);
    }
    return available;
  }

  private getAssetNumberUsingKendoIndex(index: string): string {
    let assetNumber: string = "";
    if (this.assetHierarchyKendo) {
      assetNumber = _.get(
        _.get(
          _.get(
            this.assetHierarchyKendo.treeViewLookupService.item(index),
            "item"
          ),
          "dataItem"
        ),
        "assetNumber"
      );
    }
    return assetNumber;
  }

  private scrollToAssetIndex(index: string) {
    // Scroll to the asset
    // Active Asset Index: this.assetHierarchyKendo.navigationService.activeIndex
    let kendoElement = this.assetHierarchyKendo.element.nativeElement;
    // Go to index - Top Index
    let offsetPosition =
      kendoElement
        .querySelector(`[data-treeindex='${index}']`)
        .getBoundingClientRect().top -
      kendoElement.querySelector(`[data-treeindex='0']`).getBoundingClientRect()
        .top;

    kendoElement.parentNode.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  private getActiveAssetNumber() {
    let selectedAssetIndex: string = _.get(this.selectedKeys, 0);
    if (!this.assetHierarchyKendo || !selectedAssetIndex) return "";
    
    return _.trim(
      _.get(
        _.get(
          _.get(
            this.assetHierarchyKendo.treeViewLookupService.item(
              selectedAssetIndex
            ),
            "item"
          ),
          "dataItem"
        ),
        "assetNumber"
      )
    );
  }

  // Asset Search
  public handleAssetSearchFilter(value) {
    let data = {
      assetNumber: "%" + value + "%"
    };
    //search asset list
    this.searchAssetList = Array<AssetSearchModel>();
    this.assetfetchservice.searchAssets(data).subscribe(
      val => {
        this.searchAssetList = val;
      },
      err => {
        this.showFeedback(3, "Failed to search Assets");
        console.log(err);
      }
    );
  }

  public handleAssetSearchValue(value) {
    if (!value) return;
    this.takeToAssetPath(value.assetNumber);
  }

  public takeToAssetPath(assetNumber: string) {
    let data = {
      assetNumber: assetNumber
    };
    this.assetfetchservice.getAssetPath(data).subscribe(
      val => {
        this.goToAssetNumber = val.assetPath;
        if (this.goToAssetNumber) this.redirectToAsset();
        else this.errorBox(`Not able to find asset: '${assetNumber}'`);
      },
      err => {
        this.showFeedback(3, "Failed to get asset Path");
        console.log(err);
      }
    );
  }

  public checkImpactProductionConfirmation(value: string) {
    this.productionImpact = _.trim(_.toLower(value));

    if (/^((i|y|n)(\+\+))$/gim.test(this.productionImpact)) {
      // I++, Y++, N++
      this.confirmImpactProduction(
        "This operation will over-ride the value set at all child nodes. Are you Sure?"
      );
    } else if (/^((i|y|n)(\+))$/gim.test(this.productionImpact)) {
      // I+, Y+, N+
      this.confirmImpactProduction("-1");
    } else if (/^(i|y|n)$/gim.test(this.productionImpact)) {
      // I, Y, N
      this.confirmImpactProduction("-1");
    }
  }

  public updateShutdownImpactInheritsFrom(operation: string) {
    let data = {
      username: "",
      assetID: this.attributeList["assetID"],
      operation: operation
    };
    this.assetfetchservice.updateShutdownImpact(data).subscribe(
      val => {
        if (val) {
          // Reset once completed
          this.productionImpact = "";
          // Update the attributes
          this.getAssetsAttributes(this.attributeList["assetNumber"]);
        }
      },
      err => {
        let errMessage =
          _.get(_.get(_.get(err, "error"), "contents"), "userMessage") ||
          `Error occured while performing the operation '${_.toUpper(
            this.productionImpact
          )}' for '${
            this.attributeList["assetNumber"]
          }'. Please try again or contact support.`;

        this.errorBox(errMessage);
      }
    );
  }

  private confirmImpactProduction(message: string) {
    // If message = -1, directly update the impact
    if (message == "-1") {
      this.updateShutdownImpactInheritsFrom(this.productionImpact);
    } else {
      this.confirmationService.confirmThis(
        { message: message, btnOkText: "Continue", btnCancelText: "Cancel" },
        () => {
          // Button Okay function
          this.updateShutdownImpactInheritsFrom(this.productionImpact);
        },
        () => {
          // Button Cancel function
        }
      );
    }
  }

  private errorBox(error: string) {
    this.confirmationService.confirmThis(
      { message: error, btnOkText: "Okay", hideBtnCancel: true },
      () => {
        // Button Okay function
      },
      () => {
        // Button Cancel function
      }
    );
  }
}
